module.exports = __webpack_public_path__ + "img/favicon.b732eb94.png";